import axios from "axios";
import store from 'src/store';
import {appSettingModel} from "src/datamodels/foundation";
import {lowerCaseKeys, makeFormData} from "src/utilities/utilityFunctions";
import {apiURL} from "src/utilities/utilityFunctions";
import {helpURL} from "src/utilities/utilityFunctions";
import {updateDataStore} from "src/actions/foundationActions";
import {obtainUser} from "src/containers/permissions/permissionFunctions";

//Note: formData variable needs to be an actual new FormData() object;
export const allLists = (formData,callBack,fail) => {
    //eslint-disable-next-line
    axios.post(apiURL() + "/tdp/allLists",formData,{headers: {
            "Authorization": "Bearer " + obtainUser()
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const obtainplan = (props,callBack,fail) => {
    //eslint-disable-next-line
    axios.get(apiURL() + "/tdp/plan",{headers: {
            "Authorization": "Bearer " + obtainUser()
        }}).then((evt)=>callBack(props,evt)).catch((evt)=>fail(props,evt));
};

export const submitPreLaunch = (formData,callBack,fail) => {
    axios.post(apiURL() + "/tdp/prelaunch",makeFormData(formData)).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const submitFeatureRating = (formData,callBack,fail) => {
    axios.post(apiURL() + "/tdp/featurevote",makeFormData(formData)).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const obtainAllPlans = (callBack,fail) => {
    //eslint-disable-next-line
    axios.get(apiURL() + "/tdp/allplans",{headers: {
            "DomainCode": appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};

export const subscribeNewsLetter = (email) => {
    axios.post(apiURL() + "/newsletter/add/" + email,
        {},
        {headers:{"NewsToken":"E1CB2ECD-F89C-4852-A28BA059555F2ACC","newsletter":"tdp"}})
        .then((evt)=>{
            console.dir(evt)
        });
};

export const addPersonToAccount = (accountid,person,callBack,fail) => {
    axios.post(apiURL() + "/users/account/" + accountid + "/addPerson",
        makeFormData(person),
        {headers:{
            "Authorization": "Bearer " + obtainUser(),
            "DomainCode": appSettingModel().domainCode}})
        .then((evt)=>{
            callBack(evt)
        }).catch((evt)=>fail(evt));
};

export const obtainFAQs = () => {
    axios.get(helpURL() + "blog/category/tdp-faq.json").then((evt)=>{store.dispatch(updateDataStore({faqs:lowerCaseKeys(evt.data)}))}).catch((evt)=>{console.dir(evt)});
};

export const obtainImageLists = () => {
    axios.get(helpURL() + "blog/category/tdp-imagelists.json").then((evt)=>{store.dispatch(updateDataStore({imagelists:lowerCaseKeys(evt.data)}))}).catch((evt)=>{console.dir(evt)});
};

export const createStripeSession = (price,user,callBack,fail) => {
    axios.post(apiURL() + "/tdp/stripesession",
        makeFormData({plancode:price,user:user}),
        {headers:{
                "DomainCode": appSettingModel().domainCode}})
        .then((evt)=>{
            callBack(evt)
        }).catch((evt)=>fail(evt));
};

export const sendFinalComplete = (plan,callBack,fail) =>{
    axios.get(apiURL() + "/tdp/completeSignUp",
        {headers:{
                "Authorization": "Bearer " + obtainUser(),
                "DomainCode": appSettingModel().domainCode,
                "planCode": plan
            }})
        .then((evt)=>{
            callBack(evt)
        }).catch((evt)=>fail(evt));
};

export const inviteSomeoneToTDPAPI = (person,callBack,fail) => {
    //eslint-disable-next-line
    axios.post(apiURL() + "/tdp/invite",makeFormData(person),{headers: {
            "DomainCode":appSettingModel().domainCode,
            "Authorization": "Bearer " + obtainUser(),
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};
